import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {AudioRecordModel} from '../../../api/model/audioRecord.model';
import {AudioRecordConverter} from '../../../api/model/converter/audioRecord.converter';


@Injectable({providedIn: 'root'})
export class AudioRecordDataService extends AbstractDataServiceV2<AudioRecordModel, AudioRecordConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: AudioRecordConverter) {
        super('AudioRecord', http, httpUrlGenerator, logger, config, converter);
    }
}
